/*
 *
 * MyOrders constants
 *
 */

export const DEFAULT_ACTION = '/MyOrders/DEFAULT_ACTION';
export const FETCH_ORDERS = '/MyOrders/FETCH_ORDERS';
export const CANCEL_ORDER = '/MyOrders/CANCEL_ORDER';
export const RETURN_ORDER = '/MyOrders/RETURN_ORDER';


export const DEFAULT_PAYLOAD = {
  page: 1,
  per_page: 5,
};

export const REASON_LIST = [{
  key: 'Not compatible',
  title: 'Not Compatible',
}, {
  key: 'Defective',
  title: 'Defective',
}, {
  key: 'Ordered wrong item',
  title: 'Ordered Wrong Item',
}, {
  key: 'Not Satisfied',
  title: 'Not Satisfied',
}, {
  key: 'other',
  title: 'Other',
}];

export const FILE_VALIDATION = {
  VALID_FILE_FIVE_MB: 5242880,
  ACCEPTED_FILE: '.pdf,.png,.jpg,.jpeg',
  ALERT_FIVE_MB: 'File size is more than 5 MB',
  VALIDATION_FILE_TYPE: 'File type allowed .pdf, .png, .jpg, .jpeg',
};



// WEBPACK FOOTER //
// client/containers/MyOrders/constants.js